import { Flex, FlexItem } from '@volue/wave-react';
import React from 'react';
import type { ReactNode } from 'react';

import { Navigation } from '../Navigation/Navigation';

export default function AppLayout({ children }: { children: ReactNode }) {
  return (
    <Flex flow="row" cross="stretch" className="vh100" gap="none">
      <Navigation />
      <FlexItem
        as="main"
        flex="1"
        css={{ position: 'relative', overflowY: 'auto' }}
        className="mTxxl mTn--ns pTs pTn--ns"
      >
        {children}
      </FlexItem>
    </Flex>
  );
}
